<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>Evaluaciones </strong>asociadas a {{LOCAL_DATA.nombre}}</h1>
<div mat-dialog-content>
  <div class="content p-24" fxFlex="100" fxLayout="column">

      <table mat-table [dataSource]="LOCAL_DATA.evaluaciones" #mytable class="my-table mat-elevation-z8" fxFlex="100">

        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef> Nombre </th>
          <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
        </ng-container>

        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef> Estado </th>
          <td mat-cell *matCellDef="let element"> {{element.estado}} </td>
        </ng-container>

        <ng-container matColumnDef="version">
          <th mat-header-cell *matHeaderCellDef> Version </th>
          <td mat-cell *matCellDef="let element"> {{element.version}} </td>
        </ng-container>

        <!--<ng-container matColumnDef="version">
          <th mat-header-cell *matHeaderCellDef> Versión </th>
          <td mat-cell *matCellDef="let element"> {{element.version}} </td>
        </ng-container>
        -->

        <ng-container matColumnDef="estructuraJerarquica">
          <th mat-header-cell *matHeaderCellDef> Estructura Jerarquica </th>
          <td mat-cell *matCellDef="let element"> {{element.estructuraJerarquica?.nombre}} </td>
        </ng-container>

        <ng-container matColumnDef="creador">
          <th mat-header-cell *matHeaderCellDef> Creador </th>
          <td mat-cell *matCellDef="let element"> {{element.creadorName}} </td>
        </ng-container>

        <ng-container matColumnDef="dueno">
          <th mat-header-cell *matHeaderCellDef> Dueño </th>
          <td mat-cell *matCellDef="let element"> {{element.ownerName}} </td>
        </ng-container>

        <ng-container matColumnDef="fechaInicio">
          <th mat-header-cell *matHeaderCellDef> Fecha de inicio </th>
          <td mat-cell *matCellDef="let element"> {{element.fechaInicio | date:'dd/MM/yyyy'}} </td>
        </ng-container>

        <ng-container matColumnDef="fechaFin">
          <th mat-header-cell *matHeaderCellDef> Fecha de finalización </th>
          <td mat-cell *matCellDef="let element"> {{element.fechaFin | date:'dd/MM/yyyy'}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

  </div>

</div>
<div mat-dialog-actions>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Salir' | translate}}</button>
</div>
